import { defineMessages } from 'react-intl';

export default defineMessages({
  yourCommentsTooltip: {
    id: 'frontbucket.components.diffCommentFilters.yourCommentsTooltip',
    description: 'Tooltip label for comments made by current user',
    defaultMessage: 'Your comments',
  },
  yourCommentsAriaLabel: {
    id: 'frontbucket.components.diffCommentFilters.yourCommentsAriaLabel',
    description:
      'Aria label for button to filter by comments made by current user',
    defaultMessage: 'Only show files with your comments',
  },
  allCommentsTooltip: {
    id: 'frontbucket.components.diffCommentFilters.allCommentsTooltip',
    description: 'Tooltip label for all comments filter',
    defaultMessage: 'All comments',
  },
  allCommentsAriaLabel: {
    id: 'frontbucket.components.diffCommentFilters.allCommentsAriaLabel',
    description: 'Aria label for button to filter by all comments',
    defaultMessage: 'Only show files with comments',
  },
  filterLabel: {
    id: 'frontbucket.components.diffCommentFilters.filterLabel',
    description: 'Label filter by comments section',
    defaultMessage: 'Filter by comments',
  },
});
